export class FormControlStructure {
  constructor(public name: string, public validator: string, public formControlName?: string) {}
}
